module.exports = __webpack_public_path__ + "img/DSC_1122.1ce35048.jpg";